import { Directive,  HostBinding, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[appTargetId]'
})
export class TargetIdDirective {

  @HostBinding('attr.'+environment.dataIntercomAttribute) intercomAttribute :String = this.appTargetId ;
  @Input() set appTargetId(attributeValue: string) {
    this.intercomAttribute = attributeValue;
  }

  constructor() {}
}
